import Const from '../const';
import createReducer from '../config/create_reducer';
import { screenNames } from '../../components/routes/routes_const';

const getDefaultState = () => ({
  step: 0,
  maxStep: 0,
  signupEventSent: false
});

const handleStepForScreen = (state, screen) => {
  switch (screen?.name) {
    case screenNames.wizard.aboutMe:
      return 1;
    case screenNames.wizard.question:
      return 2;
    case screenNames.wizard.advisorSelection:
      return 3;
    case screenNames.wizard.payment:
      return 4;
    case screenNames.wizard.whatsNext:
      return 5;
    default:
      return 0;
  }
};

const handler = {
  [Const.navigation.initialScreen]: (state, { initialScreen }) => ({
    ...state,
    step: handleStepForScreen(state, initialScreen)
  }),
  [Const.navigation.updateCurrentScreen]: (state, { currentScreen }) => ({
    ...state,
    step: handleStepForScreen(state, currentScreen),
    maxStep: Math.max(state.maxStep, handleStepForScreen(state, currentScreen))
  }),
  [Const.wizard.stepLoading]: (state, { stepLoading }) => ({
    ...state,
    stepLoading: stepLoading ? new Date().getTime() : null
  }),
  [Const.wizard.signupEventSent]: (state) => ({
    ...state,
    signupEventSent: true
  })
};

export default createReducer(getDefaultState(), handler);
